var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-panel"},[_c('ul',_vm._l((_vm.customerList),function(item,index){return _c('li',{key:index},[_vm._m(0,true)])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"customer"}},[_c('img',{attrs:{"src":"https://group-image.sdongpo.com/groupdev/upload_pic/com_thumb_20200722152445f0e67d3f5f17e9bd7ca58.png","alt":"","width":"100"}})])
}]

export { render, staticRenderFns }